import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/drivers-monitor")({
  component: lazyRouteComponent(() => import("./-pages/admin.drivers-monitor")),
  head: () => ({
    meta: [
      { title: "Drivers Monitor · Lecmo Admin" },
      { name: "robots", content: "noindex" },
    ],
  }),
});
